module.exports = __webpack_public_path__ + "assets/images/training-circulars7bccc7bab847e6e27a78602c37b8cd13.svg";